import styled from "styled-components";
import colors from "../../constants/colors";

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
  width: 100%;
  direction: rtl;
`;

export const AnimationWrapper = styled.div<{ $size: "small" | "medium" | "large" }>`
  width: ${({ $size }) => {
    switch ($size) {
      case "small":
        return "120px";
      case "large":
        return "280px";
      default:
        return "200px";
    }
  }};
  height: ${({ $size }) => {
    switch ($size) {
      case "small":
        return "120px";
      case "large":
        return "280px";
      default:
        return "200px";
    }
  }};
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    width: ${({ $size }) => {
      switch ($size) {
        case "small":
          return "100px";
        case "large":
          return "220px";
        default:
          return "160px";
      }
    }};
    height: ${({ $size }) => {
      switch ($size) {
        case "small":
          return "100px";
        case "large":
          return "220px";
        default:
          return "160px";
      }
    }};
    margin-bottom: 1rem;
  }
`;

export const EmptyStateTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${colors.PURPLE};
  margin: 0 0 0.75rem 0;

  @supports (background-clip: text) or (-webkit-background-clip: text) {
    background: ${colors.GRADIENT_PURPLE};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  @media (max-width: 768px) {
    font-size: 1.125rem;
    margin: 0 0 0.5rem 0;
  }
`;

export const EmptyStateDescription = styled.p`
  font-size: 1rem;
  color: ${colors.GREY_6};
  margin: 0 0 1.5rem 0;
  max-width: 400px;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 0.9375rem;
    margin: 0 0 1rem 0;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 1rem;
  width: 100%;
  max-width: 300px;

  @media (max-width: 768px) {
    margin-top: 0.75rem;
  }
`;
